import PptxGenJS from "pptxgenjs";
import {
  BRAND_WATERMARK,
  PAGE_TITLE_TEXT,
  PRIVATE_AND_CONFIDENTIAL_TEXT,
  SPLIT_PANEL_BOTTOM,
} from "./components";

export const SPLIT_TOP_MASTER = "SPLIT_TOP_MASTER";

export const splitTopMasterSlide: PptxGenJS.SlideMasterProps = {
  title: SPLIT_TOP_MASTER,
  background: {
    color: "#FFFFFF",
  },
  objects: [
    PAGE_TITLE_TEXT,
    SPLIT_PANEL_BOTTOM,
    PRIVATE_AND_CONFIDENTIAL_TEXT,
    BRAND_WATERMARK,
  ],
  slideNumber: {
    x: "50%",
    y: "95%",
    fontSize: 8,
    color: "#000000",
  },
};
